import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { I18NService } from '@core';
import { ALAIN_I18N_TOKEN, I18nPipe } from '@delon/theme';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { HttpService } from 'src/app/http/http.service';
import { TestIdDirective } from 'src/app/shared/directives/test-id.directive';

@Component({
  selector: 'app-socketio-connection-audit',
  standalone: true,
  imports: [CommonModule, I18nPipe, NzButtonModule, TestIdDirective],
  templateUrl: './socketio-connection-audit.component.html',
  styleUrls: ['./socketio-connection-audit.component.less']
})
export class SocketioConnectionAuditComponent implements OnInit {
  private readonly http = inject(HttpService);
  private readonly sanitizer = inject(DomSanitizer);
  readonly i18n = inject<I18NService>(ALAIN_I18N_TOKEN);

  iframeUrl = '';
  safeIframeUrl: SafeResourceUrl | null = null;

  ngOnInit(): void {
    this.iframeUrl = this.buildIframeUrl();
    this.safeIframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.iframeUrl);
  }

  openInNewWindow(): void {
    if (!this.iframeUrl) return;
    window.open(this.iframeUrl, '_blank', 'noopener,noreferrer');
  }

  private buildIframeUrl(): string {
    const baseUrl = String(this.http.baseUrl || window.location.origin).replace(/\/$/, '');
    return `${baseUrl}/notice/socketioConnectionAuditLog.html`;
  }
}
